import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "./useMediaQuery";

export const useCalendarEventsPopover = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const containerRef = useRef<HTMLElement | null>(null)
    const popoverRef = useRef<HTMLElement | null>(null)
    const isMobile = useMediaQuery('(max-width: 600px)')

    useEffect(() => {
        if(!isOpen) return

        const closeOnOutsideClick = (event: globalThis.PointerEvent) => {
            if(
                event.target instanceof Node &&
                !containerRef.current?.contains(event.target) &&
                !popoverRef.current?.contains(event.target)
            ){
                setIsOpen(false)
            }
        }

        document.addEventListener('pointerdown', closeOnOutsideClick)

        return () => document.removeEventListener('pointerdown', closeOnOutsideClick)
    }, [isOpen])

    return {
        isOpen,
        setIsOpen,
        containerRef,
        popoverRef,
        isMobile,
    }
}
